import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import vuetify from "./plugins/vuetify";
import moment from "moment";
import Lightbox from 'vue-easy-lightbox'

import Vidle from 'v-idle'
import VueMeta from 'vue-meta'
Vue.use(VueMeta,{
  // optional pluginOptions
  refreshOnceOnNavigation: true
})



Vue.use(Lightbox)

Vue.prototype.moment = moment;
Vue.use(VueAxios, axios);
//Vue.use(require('vue-moment'))
Vue.use(vueNumeralFilterInstaller, { locale: "es-es" });
Vue.use(Vidle)
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
//para cancelar solicitudes 7-4-21
axios.interceptors.request.use(
  config => {

    config.cancelToken = new axios.CancelToken(function (cancel) {
      store.commit('pushToken', {cancelToken: cancel})
    })
    return config
  },
  
)



router.beforeEach((to, from, next) => {

  store.commit('clearToken') // cancelar petición
  next()

});
